import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { IS_NOT_PROD_ENV, IS_WORDPRESS_WIDGET } from '../environment/typed-env';
import { LANGUAGE_CODES } from './i18.utils';
import enUS from '../locales/en-US/translation.json';
import deDE from '../locales/de-DE/translation.json';
import nlNL from '../locales/nl-NL/translation.json';
import frFR from '../locales/fr-FR/translation.json';
import itIT from '../locales/it-IT/translation.json';
import esES from '../locales/es-ES/translation.json';

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    detection: {
      order: IS_WORDPRESS_WIDGET
        ? ['htmlTag', 'querystring', 'cookie', 'sessionStorage', 'localStorage', 'navigator']
        : undefined,
      // make "en-US" as just "en"
      // convertDetectedLanguage: (lng) => lng.replace(/-\w+/gi, ''),
    },
    debug: IS_NOT_PROD_ENV && false,
    interpolation: {
      // not needed because react escapes values already
      escapeValue: false,
    },
    fallbackLng: [LANGUAGE_CODES.ENGLISH],
    defaultNS: 'translation',
    returnNull: false,
    resources: {
      'en-US': { translation: enUS },
      'de-DE': { translation: deDE },
      'nl-NL': { translation: nlNL },
      'fr-FR': { translation: frFR },
      'it-IT': { translation: itIT },
      'es-ES': { translation: esES },
    },
  });
